import React from "react";
import "./CSS/card.css";
import { BsFillArrowUpRightSquareFill } from "react-icons/bs";

export default function CardItem(props) {
  const techList = props.tech
    ? props.tech.split(",").map((tech) => tech.trim()).filter(Boolean)
    : [];
  const isGithub = props.project_url && props.project_url.includes("github.com");
  const buttonLabel = isGithub ? "View Code" : "Live Demo";

  return (
    <div className="card h-100">
      <div className="card-body">
        <h4 className="card-title">{props.title}</h4>
        <p className="card-text">{props.description}</p>
        <div className="card-meta">
          {techList.map((tech) => (
            <span className="tag" key={tech}>
              {tech}
            </span>
          ))}
        </div>
        <p className="card-date mt-3">{props.date}</p>
      </div>
      <div className="card-footer">
        <a
          href={props.project_url}
          target="_blank"
          rel="noreferrer"
          className="card-link"
        >
          {buttonLabel}
          <BsFillArrowUpRightSquareFill />
        </a>
      </div>
    </div>
  );
}
